module.exports = __webpack_public_path__ + "static/media/16.58a63486.png";